import { ClipLoader } from 'react-spinners';

// datatype for custom button props declared here
interface IAcademiaButton {
  title?: string;
  type: 'button' | 'submit' | 'reset';
  children: React.ReactNode;
  variant?: 'primary' | 'premium' | 'danger' | 'success' | 'warning' | 'info';
  customWidth?: number;
  afterBgColorClass?: string;
  additionalClassNames?: string;
  onClick?: () => void;
  fullWidth?: boolean;
  isLoading?: boolean;
  isDisabled?: boolean;
  icon?: React.ReactNode;
  isIconPositionLast?: boolean;
}

const AcademiaButton = ({
  title,
  type,
  variant = 'primary',
  children,
  customWidth,
  afterBgColorClass,
  additionalClassNames,
  onClick,
  fullWidth,
  isDisabled,
  isLoading,
  icon,
  isIconPositionLast,
}: IAcademiaButton) => {
  // rendering custom button component here
  return (
    <button
      title={title}
      type={type}
      onClick={onClick}
      style={customWidth ? { width: `${customWidth}px` } : {}}
      className={`relative border-2 text-base-white rounded-md px-8 py-3 active:scale-95  duration-300 after:absolute after:h-full after:w-0 after:top-0 after:left-0 hover:after:w-full after:origin-left after:duration-300 text-lg overflow-hidden disabled:opacity-60 disabled:cursor-not-allowed disabled:hover:after:w-0 disabled:hover:text-base-white disabled:active:scale-100 ${
        fullWidth && 'w-full'
      } ${afterBgColorClass ? afterBgColorClass : 'after:bg-base-white'} ${
        variant === 'primary'
          ? 'border-legal-dark-blue bg-legal-dark-blue hover:text-legal-dark-blue'
          : variant === 'premium'
          ? 'border-legal-dark-blue bg-legal-dark-blue text-legal-brown disabled:hover:text-legal-brown hover:text-legal-dark-blue'
          : variant === 'danger'
          ? 'border-base-red bg-base-white !text-base-red hover:!text-base-white after:!bg-base-red'
          : variant === 'success'
          ? 'border-base-dark-green bg-base-dark-green hover:text-base-dark-green'
          : variant === 'info'
          ? 'border-legal-dark-green bg-legal-dark-green hover:text-legal-dark-green'
          : 'border-base-orange bg-base-orange hover:text-base-orange'
      } ${additionalClassNames && additionalClassNames}`}
      disabled={isLoading || isDisabled}
    >
      <span className='relative flex items-center justify-center gap-2 z-10 capitalize'>
        {isLoading ? (
          <span className='flex items-center justify-center'>
            <ClipLoader
              color={variant === 'premium' ? '#D6BA88' : '#FFFFFF'}
              size={22}
            />
          </span>
        ) : icon && !isIconPositionLast ? (
          <span>{icon}</span>
        ) : null}

        {children}

        {isIconPositionLast && icon ? <span>{icon}</span> : null}
      </span>
    </button>
  );
};

export default AcademiaButton;
